import { AxiosError, AxiosRequestConfig, AxiosResponse, Method } from 'axios'
import { Context } from '@nuxt/types'
import { HTTP_REST } from '~/plugins/axios'
import { SplunkClient } from '@/helpers/splunk'

const request = async function <T = any>(
  context: Context,
  method: 'post' | 'get' | 'patch', // keyof AxiosInstance,
  path: string,
  params: any = {},
  config: AxiosRequestConfig = {}
): Promise<{ status: number | null } & T> {
  const axios = HTTP_REST(context)
  const _config = {
    withCredentials: false,
    ...config,
  }
  const methods = {
    get: () =>
      axios.get<T>(path, {
        params,
        ..._config,
      }),
    post: () =>
      axios.post<typeof params, AxiosResponse<T>>(path, params, {
        ..._config,
      }),
    patch: () =>
      axios.patch<typeof params, AxiosResponse<T>>(path, params, {
        ..._config,
      }),
  }
  try {
    const { data = {}, status = null } = await methods[method]()

    return {
      ...(data as T),
      status,
    }
  } catch (e) {
    const error = e as AxiosError<any>

    if (error?.response?.data) {
      await new SplunkClient(context).send({
        message: 'Failed',
        action: '[CLIENT]: Laravel API request',
        info: {
          errorMessage: error.response.data.message || '',
          fromPage: context.route.fullPath,
          url: error.response.config.url,
          baseURL: error.response.config.baseURL,
          status: error.response.status,
          payload: params,
          method,
        },
      })
      return { ...error.response.data, status: error.response.status }
    } else {
      // Если ошибка не связана с axios, то прокидывается дальше
      throw e
    }
  }
}

export default request
